<template>
    <div class="tarifa-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="700" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>

                        <v-card-text>
                            <v-form ref="tarifaForm" v-model="validTarifa">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="tarifaItem.nombre"
                                                label="Nombre"
                                                :rules="nombreFieldRules"
                                                :error-messages="nombreFieldErrors"
                                                :counter="255"
                                                @keydown="nombreFieldErrors = []"
                                                @keypress.enter.prevent="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-select
                                                v-model="tarifaItem.campus_id"
                                                :items="CAMPUS"
                                                label="Campus*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="campusFieldRules"
                                                :error-messages="campusFieldErrors"
                                                @blur="campusFieldErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-select
                                                v-model="tarifaItem.seccion_id"
                                                :items="SECCIONES.filter(el => el.campus_id === tarifaItem.campus_id)"
                                                label="Sección*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="seccionFieldRules"
                                                :error-messages="seccionFieldErrors"
                                                @blur="seccionFieldErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-select
                                                v-model="tarifaItem.grado_id"
                                                :items="GRADOS.filter(el => el.seccion_id === tarifaItem.seccion_id)"
                                                label="Grado*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="gradoFieldRules"
                                                :error-messages="gradoFieldErrors"
                                                @blur="gradoFieldErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showGradoForm = true"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field v-model="tarifaItem.monto" label="Monto" type="number">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="tarifaItem.inscripcion"
                                                label="Inscripción"
                                                type="number"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="tarifaItem.reinscripcion"
                                                label="Reinscripción"
                                                type="number"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <grado-form
            v-if="showGradoForm"
            form-title="Nuevo grado"
            :initial-item="null"
            @formCanceled="showGradoForm = false"
        ></grado-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
const GradoForm = () => import("@/components/cobranza/nomencladores/grado-form/grado-form")
export default {
    components: { GradoForm },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null },
        cicloId: { type: Number, default: null },
    },
    data() {
        return {
            loading: false,
            validTarifa: false,
            tarifaItem: {
                nombre: null,
                campus_id: null,
                seccion_id: null,
                grado_id: null,
                monto: null,
                inscripcion: null,
                reinscripcion: null
            },
            nombreFieldRules: [v => !!v || "Debe proporcionar un nombre"],
            nombreFieldErrors: [],
            campusFieldRules: [v => !!v || "Debe proporcionar el campus"],
            campusFieldErrors: [],
            seccionFieldRules: [v => !!v || "Debe proporcionar la sección"],
            seccionFieldErrors: [],
            gradoFieldRules: [v => !!v || "Debe proporcionar el grado"],
            gradoFieldErrors: [],

            //formularios de los nomencladores
            showGradoForm: false,

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters(["CAMPUS", "SECCIONES", "GRADOS"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validTarifa
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.tarifaForm.validate()
            if (this.validTarifa) {
                var tarifa = {
                    nombre: this.tarifaItem.nombre,
                    tipo_ciclo_id: this.cicloId,
                    grado_id: this.tarifaItem.grado_id,
                    monto: this.tarifaItem.monto,
                    inscripcion: this.tarifaItem.inscripcion,
                    reinscripcion: this.tarifaItem.reinscripcion
                }

                if (!this.isNewRecord) {
                    tarifa.id = this.initialItem.id
                }

                this.$store.dispatch(this.isNewRecord ? "ADD_TARIFA" : "UPDATE_TARIFA", tarifa).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                if (error.field === "nombre") {
                                    this.nombreFieldErrors.push(error.message)
                                }
                                if (error.field === "id") {
                                    this.nombreFieldErrors.push(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },
        cancelForm() {
            this.$emit("formCanceled")
        }
    },

    created() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_GRADOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.tarifaItem.nombre = this.initialItem.nombre

            if (this.initialItem.campus) {
                this.tarifaItem.campus_id = this.initialItem.campus.id
            }
            if (this.initialItem.seccion) {
                this.tarifaItem.seccion_id = this.initialItem.seccion.id
            }
            if (this.initialItem.grado) {
                this.tarifaItem.grado_id = this.initialItem.grado.id
            }

            this.tarifaItem.monto = this.initialItem.monto
            this.tarifaItem.inscripcion = this.initialItem.inscripcion
            this.tarifaItem.reinscripcion = this.initialItem.reinscripcion
        }
    }
}
</script>
